import { RouteConfig } from 'vue-router'
import { requireAuth } from '../auth'
import { resellingRoutes } from '../constants/agency/'
import { Modules } from '../../util/modules'

const AgencyReselling = () =>
  import(
    /* webpackChunkName: "agency-reselling" */ '@/pmd/pages/agency/AgencyReselling.vue'
  )

const AgnecyWordpressPricingPlans = () =>
  import(
    /* webpackChunkName: "agency-reselling" */ '@/pmd/components/agency/reselling/wordpress/WordpressPricingPageV2.vue'
  )



export const reselling: RouteConfig[] = [
  {
    path: '/reselling',
    name: resellingRoutes.default,
    meta: { translations: [ Modules.Reselling ] },
    component: AgencyReselling,
    beforeEnter: requireAuth,
  },
  {
    path: '/reselling/wordpress-plans',
    name: resellingRoutes.wordpressPlans,
    meta: { translations: [ Modules.Reselling ] },
    component: AgnecyWordpressPricingPlans,
    beforeEnter: requireAuth,
  },
]
